import React from 'react'

export default ({ children }) => (
  <main>
    {children}
  </main>
)



// WEBPACK FOOTER //
// /Users/dtantaru/bit-ml/src/components/Page.js